module.exports = __webpack_public_path__ + "media/app/components/MainNav/DownloadAndroidAppVi.297427cb.svg";